export const getEntitySystemsByCompanyNameQuery = (companyName: string) => {
    return `
    {
      entitySystemsByCompanyName(companyName:"${companyName}"){
        id
        entity{
          id
          name
        }
        system{
          id
          name
        }
        createdAt
        updatedAt
        integrationType
        isRequiredDaily
        isGenerateIpe
        forceGenerate
      }
    }
    `
}